// @flow
import * as pubnubNotificationService from '../../services/pubnubNotificationService';
import { bindActionCreators } from 'redux';
import { Component } from 'react';
import { connect } from 'react-redux';
import { createPubnubBidderNotificationsOnMessageReceived } from '../../redux/modules/notification';
import type { ExtractReturn } from '../../types/redux';
import { getPubnubNotificationsSubscribeKey } from '../../redux/modules/config';
import { getSessionId } from '../../redux/modules/user';
import isEqual from 'react-fast-compare';

type OwnProps = $ReadOnly<{|
    bidderId: number,
|}>;

const mapStateToProps = (state, { bidderId }: OwnProps) => {
    const subscribeKey = getPubnubNotificationsSubscribeKey(state);
    const sessionId = getSessionId();
    if (bidderId < 0) {
        return {
            channel: null,
        };
    }
    return {
        channel: `Notification.${bidderId}`,
        sessionId,
        subscribeKey,
    };
};

const mapDispatchToProps = (dispatch: Function, { bidderId }: OwnProps) =>
    bindActionCreators(
        {
            onMessage: createPubnubBidderNotificationsOnMessageReceived(bidderId),
        },
        dispatch
    );

type ReduxProps = $ReadOnly<{|
    ...ExtractReturn<typeof mapStateToProps>,
    channel: string,
    sessionId: string,
    subscribeKey: string,
|}>;
type ReduxActions = $ReadOnly<{|
    onMessage: Function,
|}>;

type Props = $ReadOnly<{|
    ...OwnProps,
    ...ReduxProps,
    ...ReduxActions,
|}>;

type State = {
    pubnubChannel: any,
};

class PubnubBidderNotificationContainer extends Component<Props, State> {
    static defaultProps = {
        bidderId: -1,
        subscribeKey: '',
    };

    state = {
        pubnubChannel: null,
    };

    componentDidMount() {
        this.connectToPubnub();
    }

    shouldComponentUpdate = (nextProps: Props, nextState: State) =>
        !isEqual(this.props, nextProps) || !isEqual(this.state, nextState);

    componentDidUpdate() {
        if (!this.state.pubnubChannel) {
            this.connectToPubnub();
        }
    }

    componentWillUnmount() {
        const { pubnubChannel } = this.state;
        if (pubnubChannel) {
            pubnubChannel.unsubscribe();
            this.setState({ pubnubChannel: null });
        }
    }

    connectToPubnub = async () => {
        const { bidderId, channel, onMessage, sessionId, subscribeKey } = this.props;
        const { pubnubChannel } = this.state;

        if (
            pubnubChannel &&
            pubnubChannel.channel &&
            pubnubChannel.channel.includes &&
            pubnubChannel.channel.includes(bidderId)
        ) {
            return;
        }
        if (Boolean(channel) && Boolean(sessionId) && Boolean(subscribeKey) && bidderId > -1) {
            await pubnubNotificationService.connect(sessionId, subscribeKey);

            const newChannel = await pubnubNotificationService.subscribe(channel, onMessage, sessionId, subscribeKey);
            this.setState({ pubnubChannel: newChannel });
        }
    };

    render() {
        return null;
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PubnubBidderNotificationContainer);
